import type { GoingOutCounts, GoingOutStatus, SharedGoingOutStatus } from "../../data/types";

/**
 * Texterna för de tre lägena, på ett ställe.
 *
 * Väljaren och chippet ska säga samma sak om samma tillstånd, men inte med
 * samma ord: man svarar "I'm going out" och är sedan "Going out". Låg
 * texterna i komponenterna skulle den skillnaden sluta vara avsiktlig.
 */

/** Vad knappen i väljaren heter — det man svarar. */
export const ANSWER_LABELS: Record<GoingOutStatus, string> = {
  OUT: "I'm going out",
  MAYBE: "Maybe",
  NOT_TONIGHT: "Not tonight",
};

/**
 * Vad chippet säger efteråt — tillståndet man är i.
 *
 * NOT_TONIGHT heter "Private" och inte "Not tonight". Tillståndet man är i
 * när man svarat nej är inte "jag stannar hemma", det är "ingen får veta
 * något om min kväll" — och det är den enda egenskap läget faktiskt har.
 */
export const STATE_LABELS: Record<GoingOutStatus, string> = {
  OUT: "Going out",
  MAYBE: "Maybe",
  NOT_TONIGHT: "Private",
};

/** Ordningen svaren visas i. Mest positiva först. */
export const ANSWER_ORDER: GoingOutStatus[] = ["OUT", "MAYBE", "NOT_TONIGHT"];

/**
 * Sammanfattningen av vännernas kväll.
 *
 * TA ALDRIG BARA NAMNEN. Den här funktionen tog tidigare en lista namn och
 * skrev "Ada and Dan are out tonight" — även när Dan hade svarat "kanske".
 * Läget försvann på vägen in, och då fanns det inget sätt att skriva rätt
 * text längre ned. Därför räknas OUT och MAYBE var för sig hela vägen hit,
 * och därför tar funktionen tal och inte strängar.
 *
 * "Kanske" är inte "ja". Den som läser raden ska kunna lita på att den
 * som står som ute faktiskt har sagt det.
 */
export function friendSummary({ out, maybe }: GoingOutCounts): string | null {
  if (!out && !maybe) return null;

  const people = (n: number) => `${n} ${n === 1 ? "friend" : "friends"}`;

  if (!maybe) return `${people(out)} ${out === 1 ? "is" : "are"} going out tonight`;
  if (!out) return `${people(maybe)} might go out tonight`;

  return `${people(out)} ${out === 1 ? "is" : "are"} going out tonight, ${maybe} maybe`;
}

/** Vad en enskild vän står som i listan. Samma två ord som chippet. */
export function friendStatusLabel(status: SharedGoingOutStatus): string {
  return STATE_LABELS[status];
}
